<div class="admin-content">
  <h2>Permissões</h2>
  <div class="admin-content__actions" routerLink="/admin/permissoes/incluir">
    <cei-button type="button">Adicionar permissao</cei-button>
  </div>

  <cei-scrollable-action-table
    #tabela
    [columns]="columns"
    [carregamento]="carregamentoTabela"
    [pageFetcher]="buscarPagina"
    [pageSize]="10"
    [sortEnabled]="true"
    [selecionavel]="true"
    [autoLoad]="autoLoad"
    [acoesLinha]="acoesLinha"
    (linhaSelecionada)="aoSelecionarLinha($event)"
    (pageLoaded)="aoCarregarPagina($event)"
    (loadError)="aoErroCarregamento($event)"
  ></cei-scrollable-action-table>
</div>
